import axios from 'axios';
import config from 'config';
import { Cookies } from 'react-cookie';

const postData = async (data: any) => {
  const cookie = new Cookies();
  const accessToken = cookie.get('access_token');
  const accessTokenQueryParam = accessToken ? `?accesstoken=${accessToken}` : '';

  try {
    await axios({
      method: 'post',
      url: `${config.servicesURL}/kbyg/feedback/camera${accessTokenQueryParam}`,
      data,
    });
    return true;
  } catch (error) {
    console.error('Error submitting camera feedback', error);
    return false;
  }
};

export default postData;
